import React, { useGlobal } from 'reactn';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Divider, Drawer, Typography } from '@material-ui/core';
import DashboardIcon from '@material-ui/icons/Dashboard';
import PeopleIcon from '@material-ui/icons/People';
import DeviceHub from '@material-ui/icons/DeviceHub';
import NotificationImportant from '@material-ui/icons/NotificationImportant';
import AccountBoxIcon from '@material-ui/icons/AccountBox';
import CheckCircleIcon from '@material-ui/icons/CheckCircle'; // groen lampje
import CancelIcon from '@material-ui/icons/Cancel'; // rood kruisje
import { green, red } from '@material-ui/core/colors';

import { SidebarNav } from './components';

const useStyles = makeStyles(theme => ({
  drawer: {
    width: 240,
    [theme.breakpoints.up('lg')]: {
      marginTop: 64,
      height: 'calc(100% - 64px)'
    }
  },
  root: {
    backgroundColor: theme.palette.white,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    padding: theme.spacing(2)
  },
  divider: {
    margin: theme.spacing(2, 0)
  },
  nav: {
    marginBottom: theme.spacing(2)
  }
}));

const Sidebar = props => {
  //update voor event en start tijd.
  const { open, variant, onClose, className, devices = [], ...rest } = props;
  //const { open, variant, onClose, className, ...rest } = props;

  const classes = useStyles();
  const [ user ] = useGlobal('user');

  
  // robuuste admin-check (dekt boolean én string 'true')
  const isAdmin = !!(user && (user.admin === true || user.admin === 'true'));

  

 const pages = [
    { title: 'Dashboard', href: '/dashboard', admin: false, icon: <DashboardIcon /> },
    { title: 'Notificaties', href: '/notify', admin: true, icon: <NotificationImportant /> },
    { title: 'Gebruikers', href: '/users', admin: true, icon: <PeopleIcon /> },
    { title: 'Apparaten', href: '/devices', admin: true, icon: <DeviceHub /> },
    { title: 'System', href: '/system', admin: true, icon: <DashboardIcon /> },
    { title: 'Mijn Profiel', href: '/account', admin: false, icon: <AccountBoxIcon /> },
  ];
  
  return (
    <Drawer
      anchor="left"
      classes={{ paper: classes.drawer }}
      onClose={onClose}
      open={open}
      variant={variant}
    >
      <div
        {...rest}
        className={clsx(classes.root, className)}
      >
        <Typography
          className={classes.name}
          variant="h5"
        >
          Welkom terug, {user.name ? user.name.charAt(0).toUpperCase() + user.name.slice(1) : ''}! 
          
      </Typography>
        <Divider className={classes.divider} />
        <SidebarNav
          className={classes.nav}
          pages={pages}
        />
        {isAdmin && Array.isArray(devices) && devices.length > 0 && (               
          <>
            <Divider className={classes.divider} />
            <Typography variant="subtitle1">Apparaten</Typography>
            {props.devices.map((dev, idx) => {
              const now = Date.now();
              const lastSeen = new Date(dev.eventTime).getTime();
              const diffMinutes = Math.abs(now - lastSeen) / 60000;

              const isOnline = diffMinutes < 15 && dev.eventTime; // kleine marge 15minuten check

              return (
                <div key={idx} style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                  <div style={{ flex: 1 }}>
                    <Typography variant="body2" color="textPrimary">
                      Serial: {dev.serial}
                    </Typography>
                    <Typography variant="caption" color="textSecondary">
                      Gestart: {new Date(dev.startedDate).toLocaleString()}
                    </Typography><br />
                    <Typography variant="caption" color="textSecondary">
                      Laatste event: {new Date(dev.eventTime).toLocaleString()}
                    </Typography>
                  </div>
                  <div style={{ marginLeft: 8 }}>
                    {isOnline ? (
                      <CheckCircleIcon style={{ color: green[500] }} titleAccess="Online" />
                    ) : (
                      <CancelIcon style={{ color: red[500] }} titleAccess="Offline" />
                    )}
                  </div>
                </div>
              );
            })}

          </>
        )}
      </div>
    </Drawer>
  );
};


Sidebar.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired,
  variant: PropTypes.string.isRequired
};

export default Sidebar;
